'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

import { useRollbar } from '@rollbar/react';

import { revalidate } from './actions';

function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const pathname = usePathname();
  const rollbar = useRollbar();

  useEffect(() => {
    // Log the error to an error reporting service
    rollbar.error(error);
    void revalidate(pathname ?? '/');
  }, [error, pathname, rollbar]);

  return (
    <div>
      <h2>Something went wrong!</h2>
      <button
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
      >
        Try again
      </button>
    </div>
  );
}

export default Error;
